import classNames from "classnames";
import { createUseStyles } from "react-jss";
import Button from "../../Components/Button";
interface Props {
  className?: string;
  title?: string;
  children: React.ReactNode;
  button?: {
    label: string;
    onClick: () => void;
  };
}

const useStyles = createUseStyles({
  root: {
    background: "#fff",
    padding: "10px 30px 30px",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  title: {
    marginBottom: 25,
    marginTop: 0,
    borderBottom: "1px solid #e1e5ed",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 10,
    alignItems: "center",
    "& h3": {
      margin: "0 10",
    },
  },
});

const DashboardCard = ({ className, title, children, button }: Props) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.title}>
        {title && <h3>{title}</h3>}
        {button?.label && (
          <Button label={button.label} onClick={button.onClick} />
        )}
      </div>
      <div className={classes.cardContent}>{children}</div>
    </div>
  );
};

export default DashboardCard;
